import React, { useState, useEffect, useCallback } from 'react';
import { rewardService } from '../api/services';
import { formatDate } from '../utils/helpers';

const STATUS_LABEL = { PENDING: '待審核', APPROVED: '已同意', REJECTED: '已拒絕', CANCELLED: '已取消' };

// 兌換審核佇列：列出兌換申請，PENDING 可同意/拒絕。具 reward.manage 權限者使用（商城頁與後台共用）。
// onReviewed 供呼叫端在審核後刷新其他資料（如後台明細或自己的點數）。
const RewardReviewList = ({ onReviewed }) => {
  const [items, setItems] = useState([]);
  const [statusFilter, setStatusFilter] = useState('PENDING');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    return rewardService.reviewQueue(statusFilter || undefined)
      .then((res) => setItems(res.data?.items || []))
      .catch((err) => setError(err.response?.data?.error || err.message))
      .finally(() => setLoading(false));
  }, [statusFilter]);

  useEffect(() => { load(); }, [load]);

  const act = async (fn, id) => {
    setBusyId(id);
    setError('');
    try {
      await fn();
      await load();
      onReviewed?.();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setBusyId('');
    }
  };

  const handleApprove = (r) => {
    if (!window.confirm(`確定同意「${r.user_name}」兌換「${r.reward_name}」x${r.quantity}（共 ${r.total_points} 點）？同意後將扣除其點數。`)) return;
    act(() => rewardService.approve(r.id), r.id);
  };

  const handleReject = (r) => {
    const note = window.prompt('請輸入拒絕原因（選填）：', '');
    if (note === null) return; // 使用者取消
    act(() => rewardService.reject(r.id, note), r.id);
  };

  return (
    <div className="reward-review">
      <div className="reward-subtabs">
        {['PENDING', 'APPROVED', 'REJECTED', ''].map((s) => (
          <button key={s || 'ALL'} className={`btn btn-sm ${statusFilter === s ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setStatusFilter(s)}>
            {s ? STATUS_LABEL[s] : '全部'}
          </button>
        ))}
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <div className="reward-empty">載入中...</div>
      ) : items.length === 0 ? (
        <div className="reward-empty">目前沒有符合條件的兌換申請</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="reward-redemption-table">
            <thead>
              <tr><th>申請時間</th><th>兌換人</th><th>商品</th><th>數量</th><th>點數</th><th>備註</th><th>狀態</th><th>操作</th></tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id}>
                  <td>{formatDate(r.created_at)}</td>
                  <td>{r.user_name}</td>
                  <td>{r.reward_name}</td>
                  <td>{r.quantity}</td>
                  <td>{r.total_points}</td>
                  <td title={r.review_note ? `審核備註：${r.review_note}` : ''}>{r.note || '-'}</td>
                  <td><span className={`reward-status-badge reward-status-${r.status}`}>{STATUS_LABEL[r.status] || r.status}</span></td>
                  <td>
                    {r.status === 'PENDING' ? (
                      <div className="btn-group">
                        <button className="btn btn-sm btn-primary" disabled={busyId === r.id} onClick={() => handleApprove(r)}>同意</button>
                        <button className="btn btn-sm btn-danger" disabled={busyId === r.id} onClick={() => handleReject(r)}>拒絕</button>
                      </div>
                    ) : (
                      <span className="reward-stock">{r.reviewer_name ? `${r.reviewer_name}` : '-'}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RewardReviewList;
